import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../utils/dateFormatter';
import './PlantCard.css';

function PlantCard({ plant }) {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/plants/${plant._id}`);
  };

  return (
    <div className="plant-card" onClick={handleCardClick}>
      <div className="plant-card-image">
        <img 
          src={plant.imageUrl} 
          alt={plant.name}
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/400x300?text=Plant+Image';
          }}
        />
        {plant.favorite && <span className="favorite-star">⭐</span>}
      </div>
      <div className="plant-card-content">
        <h3>{plant.name}</h3>
        {plant.species && <p className="plant-species">{plant.species}</p>}
        <div className="plant-card-meta">
          <div className="plant-badges">
            <span className="plant-category">{plant.category}</span>
            {plant.tags && plant.tags.length > 0 && 
              plant.tags.map((tag, index) => (
                <span key={index} className="plant-tag">{tag}</span>
              ))
            }
          </div>
          {plant.acquisitionDate && (
            <span className="plant-date">
              {formatDate(plant.acquisitionDate)}
            </span>
          )}
        </div>
        {(plant.careNotes || plant.soilMixNotes) && (
          <div className="plant-card-notes">
            {plant.careNotes && (
              <div className="note-preview">
                <strong>🌱 Care:</strong> {plant.careNotes.substring(0, 60)}
                {plant.careNotes.length > 60 && '...'}
              </div>
            )}
            {plant.soilMixNotes && (
              <div className="note-preview">
                <strong>🪴 Soil:</strong> {plant.soilMixNotes.substring(0, 60)}
                {plant.soilMixNotes.length > 60 && '...'}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default PlantCard;
